<template>
  <v-row no-gutters class="mobile-panel fill-width" style="height: calc(100vh - 70px)">
    <v-col cols="12">
      <v-row no-gutters style="height: 50px !important" class="px-4 mobile-panel-header" align="center">
        <v-col cols="auto" class="text-body-2 font-weight-medium primary-color">
          {{ $i18n.t('dialog.search.offersFilter') }}
        </v-col>
        <v-spacer />
        <v-col cols="auto">
          <v-icon color="font" size="20" @click="isFilterVisible = false">mdi-close</v-icon>
        </v-col>
      </v-row>
      <v-row no-gutters style="height: calc(100vh - 120px) !important">
        <v-col cols="12">
          <v-row no-gutters class="text-body-2 font-weight-medium primary-color pt-4 px-4">
            {{ $i18n.t('dialog.search.parameters') }}
          </v-row>
          <v-row no-gutters class="pt-4 px-4">
            <v-col cols="12">
              <data-input
                v-bind="{ ...selectInputBind, multiple: true }"
                v-model="currentFilter['category']"
                :items="offersLayersIdsList"
                :label="$i18n.t('dialog.search.category')"
              />
            </v-col>
          </v-row>
          <v-row no-gutters class="pt-4 d-flex justify-space-between pb-5 px-4" align="center">
            <v-col cols="5.5">
              <data-input
                v-bind="numberInputBind"
                v-model="currentFilter['areaFrom']"
                :label="$i18n.t('dialog.search.areaFrom')"
              >
                <template #append>
                  <span class="input-append">{{ areaAttributeUnit }}</span>
                </template>
              </data-input>
            </v-col>
            <v-col cols="auto" class="px-1"> - </v-col>
            <v-col cols="5.5">
              <data-input
                v-bind="numberInputBind"
                v-model="currentFilter['areaTo']"
                :label="$i18n.t('dialog.search.areaTo')"
              >
                <template #append>
                  <span class="input-append">{{ areaAttributeUnit }}</span>
                </template>
              </data-input>
            </v-col>
          </v-row>
          <v-row no-gutters class="text-body-2 font-weight-medium primary-color pt-4 px-4 border-top">
            {{ $i18n.t('dialog.search.location') }}
          </v-row>
          <v-row no-gutters class="pt-4 px-4">
            <v-col cols="12">
              <data-input
                v-bind="{ ...selectInputBind, multiple: true }"
                v-model="currentFilter['voivodeship']"
                :items="locationItems['voivodeships']"
                :label="$i18n.t('dialog.search.voivodeship')"
              />
            </v-col>
          </v-row>
          <v-row no-gutters class="pt-4 pb-5 px-4">
            <v-col cols="6" class="pr-1">
              <data-input
                v-bind="{ ...selectInputBind, multiple: true }"
                v-model="currentFilter['district']"
                :items="locationItems['districts']"
                :label="$i18n.t('dialog.search.district')"
              />
            </v-col>
            <v-col cols="6" class="pl-1">
              <data-input
                v-bind="{ ...selectInputBind, multiple: true }"
                v-model="currentFilter['commune']"
                :items="locationItems['communes']"
                :label="$i18n.t('dialog.search.commune')"
              />
            </v-col>
          </v-row>
          <v-row no-gutters class="text-body-2 font-weight-medium primary-color pt-4 px-4 border-top">
            {{ $i18n.t('dialog.search.additionalFilters') }}
          </v-row>
          <v-row no-gutters class="pt-4 px-4">
            <v-col cols="8">
              <data-input
                v-bind="{ ...selectInputBind, items: kmItems, returnObject: true, disabledSorting: true }"
                v-model="currentFilter['distanceFromHighway']"
                :label="$i18n.t('dialog.search.distanceFromHighway')"
              >
                <template #append>
                  <span class="input-append">{{ distanceFromHighwayAttributeUnit }}</span>
                </template>
              </data-input>
            </v-col>
          </v-row>
          <v-row no-gutters class="pt-4 px-4">
            <v-col cols="8">
              <data-input
                v-bind="{ ...selectInputBind, items: kmItems, returnObject: true, disabledSorting: true }"
                v-model="currentFilter['distanceFromRailway']"
                :label="$i18n.t('dialog.search.distanceFromRailway')"
              >
                <template #append>
                  <span class="input-append">{{ distanceFromRailwayAttributeUnit }}</span>
                </template>
              </data-input>
            </v-col>
          </v-row>
          <v-row no-gutters class="pt-4 px-4">
            <v-col cols="8">
              <data-input
                v-bind="{ ...selectInputBind, items: mItems, returnObject: true, disabledSorting: true }"
                v-model="currentFilter['buildingHeight']"
                :label="$i18n.t('dialog.search.buildingHeight')"
              >
                <template #append>
                  <span class="input-append">{{ buildingHeightAttributeUnit }}</span>
                </template>
              </data-input>
            </v-col>
          </v-row>
          <v-row no-gutters class="pt-6 px-4">
            <v-col cols="6" class="pr-2">
              <base-button
                color="secondary"
                cancel
                text="buttons.clearFilters"
                width="100%"
                height="36px"
                @click="clearFilter"
              />
            </v-col>
            <v-col cols="6" class="pl-2">
              <base-button color="secondary" text="buttons.search" width="100%" height="36px" @click="filter" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import { get, sync } from 'vuex-pathify';
import BaseButton from '@/components/shared/buttons/BaseButton';
import DataInput from '@/components/shared/inputs/DataInput';
export default {
  name: 'TheMobileFilters',
  components: { BaseButton, DataInput },
  computed: {
    filterPayload: sync('map/filterPayload'),
    layers: get('featuresData/layers'),
    currentLng() {
      return this.$i18n.locale;
    },
    settingsValues: get('admin/settings'),
    locationItems: get('featuresData/locationItems'),
    offersLayersIds() {
      return this.$_config.languages.reduce((total, lng) => {
        total[lng] = ['brownfields', 'greenfields', 'invested'].reduce((tot, cur) => {
          tot[cur] = this.settingsValues[`${cur.toLocaleUpperCase()}_LAYERS_SETTING`]?.value?.layers?.[lng];
          return tot;
        }, {});
        return total;
      }, {});
    },
    offersLayersIdsList() {
      return Object.values(this.offersLayersIds[this.currentLng])
        .filter(layerId => !!layerId)
        .map(layerId => {
          return { text: this.layers[layerId]?.name, value: layerId };
        });
    },

    dataSources: get('featuresData/dataSources'),
    offersDataSource() {
      return this.dataSources[this.settingsValues['OFFERT_SETTING']?.value?.datasource];
    },
    offersAttributesNames() {
      const { value: offersSettingValue } = this.settingsValues['OFFERT_SETTING'];
      const { value: filterSettingValue } = this.settingsValues['FILTER_SETTING'];
      return {
        name: offersSettingValue.name_attribute,
        voivodeship: filterSettingValue?.attributes.voivodeship_attribute,
        district: filterSettingValue?.attributes.district_attribute,
        commune: filterSettingValue?.attributes.commune_attribute,
        area: offersSettingValue.area_attribute,
        distanceFromHighway: filterSettingValue?.attributes.highway_distance_attribute,
        distanceFromRailway: filterSettingValue?.attributes.railway_distance_attribute,
        buildingHeight: filterSettingValue?.attributes.building_height_attribute,
      };
    },
    areaAttributeUnit() {
      return (
        this.offersDataSource.attributes.find(attribute => attribute.name === this.offersAttributesNames.area)
          ?.measurement_unit?.symbol || ''
      );
    },
    distanceFromHighwayAttributeUnit() {
      return (
        this.offersDataSource.attributes.find(
          attribute => attribute.name === this.offersAttributesNames.distanceFromHighway
        )?.measurement_unit?.symbol || ''
      );
    },
    distanceFromRailwayAttributeUnit() {
      return (
        this.offersDataSource.attributes.find(
          attribute => attribute.name === this.offersAttributesNames.distanceFromRailway
        )?.measurement_unit?.symbol || ''
      );
    },
    buildingHeightAttributeUnit() {
      return (
        this.offersDataSource.attributes.find(attribute => attribute.name === this.offersAttributesNames.buildingHeight)
          ?.measurement_unit?.symbol || ''
      );
    },

    isFilterVisible: sync('tools/isFilterVisible'),
    selectInputBind() {
      return {
        dataType: { name: 'select' },
        hideDetails: true,
      };
    },
    numberInputBind() {
      return {
        dataType: { name: 'float' },
        hideDetails: true,
        showArrows: false,
        allowNegative: false,
      };
    },
    kmItems() {
      return [
        {
          min: null,
          max: 5,
          text: `${this.$i18n.t('dialog.search.lessThan', { value: 5 })} km`,
        },
        {
          min: 5,
          max: 10,
          text: `5-10 km`,
        },
        {
          min: 10,
          max: null,
          text: `${this.$i18n.t('dialog.search.moreThan', { value: 10 })} km`,
        },
      ];
    },
    mItems() {
      return [
        {
          min: null,
          max: 20,
          text: `${this.$i18n.t('dialog.search.lessThan', { value: 20 })} m`,
        },
        {
          min: 20,
          max: 30,
          text: `20-30 m`,
        },
        {
          min: 30,
          max: null,
          text: `${this.$i18n.t('dialog.search.moreThan', { value: 30 })} m`,
        },
      ];
    },
  },
  data: () => ({
    currentFilter: {},
  }),
  methods: {
    clearFilter() {
      this.filterPayload = {};
      this.isFilterVisible = false;
    },
    filter() {
      this.filterPayload = JSON.parse(JSON.stringify(this.currentFilter));
      this.isFilterVisible = false;
    },
  },
  watch: {
    isFilterVisible(nV) {
      if (nV) {
        this.currentFilter = JSON.parse(JSON.stringify(this.filterPayload));
      }
    },
  },
};
</script>
